<template>
	<div class="wrapper-template">
		<div class="answer" v-for="answer in answers" :key="answer.id">
			<label
				:for="`answer-${questionId}-${answer.id}`"
				:class="[ isSelected(answer.id) ? 'answer-selected' : 'answer-text' ]">
				{{answer.name}}
			</label>
			<v-checkbox
				:id="`answer-${questionId}-${answer.id}`"
				:value="answer.id"
				v-model="answersSelected"
			></v-checkbox>
		</div>
	</div>
</template>
<script>

function isSelected(id) {
	this.$emit('selected-icon', id);
	return !!this.answersSelected.find(a => a === id);
}

function handlerAnswersSelected(newVal, oldVal) {
	if (newVal === 0) {
		this.$store.commit('UPDATE_POLL_PROGRESS', -1);
	}
	if (oldVal === 0) {
		this.$store.commit('UPDATE_POLL_PROGRESS', 1);
	}
}

function data() {
	return {
		answersSelected: [],
	};
}

export default {
	name: 'check-button-template',
	data,
	methods: {
		handlerAnswersSelected,
		isSelected,
	},
	props: {
		answers: {
			default: () => [],
			type: Array,
		},
		questionId: Number,
	},
	watch: {
		'answersSelected.length': handlerAnswersSelected,
	},
};
</script>




// WEBPACK FOOTER //
// src/components/polls/check-button-template.vue